import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";
import { LoadingDiv } from "../master/Master";
import { formatToDate } from "../master/FormatToDateTime";
import Pagination from "../components/Pagination";
import { getFollowupsList } from "../enquiry/components/Master";
import FollowUpModal from "./FollowUpModel";

export default function FeesFollowupTable({ filters, setFilters }) {
    const hasAccess = usePrivateLink();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [modeldata, setmodeldata] = useState([]);

    const handleFunction = () => {
        getFollowupsList({
            setLoading,
            filters,
            setData,
        });
    };

    useEffect(() => {
        handleFunction();
    }, [filters]);
    return (
        <>
            {loading && <LoadingDiv />}
            <div className="table-responsive">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="text-black">
                        Total Followups: -{" "}
                        <span className="text-primary">{data?.total}</span>
                    </h6>
                    {/* SEARCH */}
                    <div className="col-4 p-1">
                        <div className="form-floating form-floating-outline">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Name, Mobile"
                                value={filters?.search}
                                onChange={(e) =>
                                    setFilters({
                                        ...filters,
                                        search: e.target.value.toUpperCase(),
                                    })
                                }
                            />
                            <label>Search</label>
                        </div>
                    </div>
                </div>

                <table className="table table-sm table-hover">
                    <thead className="text-nowrap">
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Father's Name</th>
                            <th>Mobile</th>
                            <th>Course</th>
                            <th>Admission Date</th>
                            <th>Counselor</th>
                            <th>Last Follow Up</th>
                            <th>Response</th>
                            <th>Next Follow Up</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-capitalize">
                        {data?.data?.map((item, i) => (
                            <tr key={item.id}>
                                <td>{i + 1}</td>
                                <td>
                                    <Link
                                        to={`/student/details?id=${item?.fees?.id}`}
                                        className="fw-semibold"
                                    >
                                        {item?.fees?.name}{" "}
                                        {item?.fees?.registration_no &&
                                            `(${item?.fees?.registration_no})`}
                                    </Link>
                                </td>
                                <td>{item?.fees?.father_name}</td>
                                <td>{item?.fees?.phone}</td>
                                <td>{item?.fees?.latest_course_and_fee?.course?.title}</td>
                                <td>{formatToDate(item?.fees?.admission_date)}</td>
                                <td>
                                    {item?.counselor?.name} ({item?.counselor?.registration_no})
                                </td>
                                <td>{formatToDate(item?.followup_date)}</td>
                                <td>{item?.response}</td>
                                <td>{formatToDate(item?.next_followup_date)}</td>

                                <td>
                                    {hasAccess("/student/details") && (
                                        <Link to={`/student/details?id=${item?.fees?.id}&type=BasicDetails`}>
                                            <i className="ri-eye-line text-primary cursor-pointer ri-20px"></i>
                                        </Link>
                                    )}

                                    {hasAccess("/enquiry/followups") && (
                                        <i
                                            className="ri-phone-fill text-warning cursor-pointer ri-20px ms-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#feefollowup"

                                            onClick={() => {
                                                setmodeldata({
                                                    data: item?.fees?.latest_course_and_fee,
                                                    student: item?.fees,
                                                    followups: item?.fees?.followups || [],
                                                });

                                            }}

                                        ></i>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pagination data={data} setFilters={setFilters} filters={filters} />

                <FollowUpModal
                    data={modeldata}
                    setLoading={setLoading}
                    handleFunction={handleFunction}
                />

            </div>
        </>
    );
}
